var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('button',{on:{"click":function($event){_vm.count++}}},[_vm._v("\n    "+_vm._s(_vm.count > 1 ? "💀 Ouch!" : ("You clicked me " + _vm.count + " times. 👀"))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }